//@flow
import type { DropzoneFile } from 'react-dropzone';
import { logError } from '../../helpers';
import { getBuyerToken } from 'dibs-cookie-jar';

export const PROFILE_IMAGE_TYPE: 'TRADE_PROFILE' = 'TRADE_PROFILE';
export const SPLASH_IMAGE_TYPE: 'TRADE_SPLASH' = 'TRADE_SPLASH';

type ProfileImage = typeof PROFILE_IMAGE_TYPE | typeof SPLASH_IMAGE_TYPE;

const getImagePath = (userToken, photoType: ProfileImage = 'TRADE_PROFILE') =>
    `/soa/media-1/2/photo/${photoType}?userToken=${userToken || ''}`;

type ImageType = {
    apiType: 'photo',
    dimension: {
        apiType: 'dimension',
        width: number,
        height: number,
    },
    id: string,
    mediaType: 'PHOTO',
    owner: {
        apiType: 'anchor',
        sourceId: string,
        sourceType: string,
    },
    path: 'string',
    status: 'ACTIVE',
    type: {
        apiType: 'photoType',
        id: number,
        name: ProfileImage,
    },
};

type ImageUploadType = { hasError?: boolean, image?: ImageType };

export function upload(
    file: DropzoneFile,
    firmId: string,
    photoType: ProfileImage = PROFILE_IMAGE_TYPE
): Promise<ImageUploadType> {
    const { userToken } = getBuyerToken(document.cookie);
    const mediaJson = {
        apiType: 'photo',
        status: 'ACTIVE',
        owner: {
            apiType: 'anchor',
            sourceId: firmId,
            sourceType: 'FIRM',
        },
    };

    const formData = new FormData();
    formData.append('files', file);
    formData.append('pathSegment', '/trade');
    formData.append('mediaJson', JSON.stringify(mediaJson));

    return fetch(getImagePath(userToken, photoType), {
        method: 'POST',
        body: formData,
    })
        .then(response => {
            if (!response.ok) {
                logError(`Could not upload photo; got code ${response.status}`);
                return Promise.reject({ hasError: true });
            }
            return response.json();
        })
        .then(json => {
            const { result } = json;
            return { image: result };
        })
        .catch(e => {
            logError(e);
            return { hasError: true };
        });
}
